<template>
  <div>
    <section class="hero is-info is-medium is-bold">
      <headerbar></headerbar>
     </section>

     <vue-simple-spinner id="spinner" style="padding: 100px"></vue-simple-spinner>

     <section id="main_content" class="section">

         <div class="container">
           <div class="tile is-ancestor">
             <div class="tile is-8 is-parent">
               <div class="tile is-child">
                 <h1 class="title">{{post.title}}</h1>
                 <h2 class="subtitle">
                   <p v-if="post.authors"><em>de</em>
                   <span class="authors" v-if="post.authors" v-for="auth in post.authors" v-bind:key="auth">{{auth}}</span></p>
                 </h2>
               </div>
             </div>
           </div>

           <div class="tile is-ancestor">
             <div class="tile is-4 is-vertical is-parent">
               <div class="tile is-child box has-text-centered" v-if="post.cover">
                 <img :src="post.cover" alt="image" class="border-tlr-radius book-cover">
                 <article class="message is-link" v-if="post.price_paper">
                   <div class="message-header">
                     <p>Preço regular</p>
                   </div>
                   <div class="message-body has-text-centered">
                     <p class="is-size-4 has-text-dark">{{post.price_paper}}€ </p>
                     <form action="https://www.paypal.com/cgi-bin/webscr" method="post">
                       <input type="hidden" name="cancel_return" v-bind:value="this.base_url + this.$route.fullPath">
                       <!-- TODO: send user to payment confirm page with instructions -->
                       <input type="hidden" name="return" v-bind:value="this.base_url + this.$route.fullPath">
                       <input type="hidden" name="notify_url" v-bind:value="this.base_url + '/update_payments'">
                     <input type="hidden" name="business" :value="this.paypal_business">
                     <input type="hidden" name="cmd" value="_xclick">
                     <input type="hidden" name="item_name" :value="post.title">
                     <input type="hidden" name="amount" :value="post.price_paper">
                     <input type="hidden" name="currency_code" value="EUR">
                     <!-- <input type="submit" value="Encomendar" name="submit" border="0" class="button is-danger"> -->
                     </form>
                   </div>
                 </article>
                 <article class="message is-dark" v-if="post.title">
                   <div class="message-header">
                     <p>Personalizado</p>
                   </div>
                   <div class="message-body has-text-centered">
                     <p class="is-size-4 has-text-dark">Personalize a sua prenda</p><br>
                     <!-- <p><button v-if="post.price_ebook" v-on:click="showDownloadModalViewDISABLED" data-target="modal-download" class="button is-danger">Download Ebook</button></p> -->
                     <!-- <p><button v-if="!post.price_ebook" v-on:click="showModalViewDISABLED" class="button is-danger modal-button-ebook" data-target="modal-ter" aria-haspopup="true">Contactar</button></p> -->
                   </div>
                 </article>
                 <div class="has-text-left">
                   <p><small>Detalhe 1:</small> {{post.editor}}</p>
                   <p><small>Detalhe 2:</small>  {{post.year}}</p>
                   <p><small>Categorias:</small>  <span class="authors" v-if="post.categories" v-for="cat in post.categories" v-bind:key="cat">{{cat}}</span></p>
                 </div>
               </div>
             </div>
             <div class="tile is-parent">
               <div class="tile is-child">
                 <h2 class="subtitle divider">Descrição</h2>
                 <p class="text-content" v-html="post.synopsis"></p>
                 <br>
                 <!-- <h2 class="subtitle divider">Autor</h2>
                 <p class="text-content" v-html="post.author_text"></p>
                 <br> -->
               </div>
             </div>
           </div>

         </div>
       </section>

     <footerbar></footerbar>

      <div id="modal-download" class="modal modal-view-download">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Ebook Download</p>
            <button v-on:click="hideDownloadModalView" id="button-close-download" class="delete" aria-label="close"></button>
          </header>
          <section class="modal-card-body">
            <p>Usa ePub para ler no teu dispositivo móvel (smartphone ou leitor de ebooks) e PDF para o computador.</p>
            <p class="has-text-centered margin-8">
             <a class="button is-dark" :href="post.file_epub" v-if="post.file_epub">Download ePub</a>
             <a class="button is-dark" :href="post.file_pdf" v-if="post.file_pdf">Download PDF</a>
             </p>
          </section>
          <footer class="modal-card-foot">
          </footer>
        </div>
      </div>

     <div id="modal-ter" class="modal modal-view">
       <div class="modal-background"></div>
       <div class="modal-card">
         <header class="modal-card-head">
           <p class="modal-card-title">Pague quanto quiser!</p>
           <button v-on:click="hideModalView" id="button-close" class="delete" aria-label="close"></button>
         </header>
         <section class="modal-card-body">
           <p class="is-medium">Sim, pode escolher quanto quer pagar ou até descarregar gratuitamente.<br> Ao contribuir está a ajudar a Neolivros a crescer e a aumentar o catálogo disponível.</p>
             <p class="has-text-centered">
            <a class="button is-light is-dark pay-button" v-on:click="pay">€1</a>
            <a class="button is-light pay-button" v-on:click="pay">€2</a>
            <a class="button is-light pay-button" v-on:click="pay">€3</a>
            <a class="button is-light pay-button" v-on:click="pay">€5</a>
            <a class="button is-light pay-button" v-on:click="pay">€10</a>
            <a class="button is-light pay-button" v-on:click="pay">Grátis</a>
            </p>
            <img alt="" border="0" width="1" height="1" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" >
         </section>
         <footer class="modal-card-foot">
           <form id="paypal-form" action="https://www.paypal.com/cgi-bin/webscr" method="post" class="form-paypal">
             <input type="hidden" name="cancel_return" v-bind:value="this.base_url + this.$route.fullPath + '?show_download=true'">
             <input type="hidden" name="return" v-bind:value="this.base_url + this.$route.fullPath + '?show_download=true'">
             <input type="hidden" name="notify_url" v-bind:value="this.base_url + '/update_payments'">
             <input type="hidden" name="business" :value="this.paypal_business">
            <input type="hidden" name="cmd" value="_xclick">
            <input type="hidden" name="item_name" :value="post.title">
            <input type="hidden" name="amount" :value="1">
            <input type="hidden" name="currency_code" value="EUR">
            <input type="submit" value="Pagar" name="submit" border="0" class="button is-danger button-pay">
            </form>
           <button v-on:click="showDownloadModalView" data-target="modal-download" class="button is-danger button-download" style="display: none">Download</button>
         </footer>
       </div>
     </div>
  </div>
</template>

<script>
import { settingsRef, booksRef, navRef, mediaRef } from '../firebase_config'
import Spinner from 'vue-simple-spinner'
import Header from './Header'
import Foot from './Foot'
export default {
  name: 'home',
  components: {
    'headerbar': Header,
    'footerbar': Foot,
    'vue-simple-spinner': Spinner
  },
  data () {
    return {
      orthography: {
        'OO': 'Ortografia Original',
        'OA': 'Ortografia actualizada (1945)',
        'AO': 'Novo acordo ortográfico (1990)'
      },
      // 'base_url': 'https://neolivrostest.firebaseapp.com',
      'base_url': 'https://www.neolivros.com',
      'paypal_business': 'RZHCV3LPR7GRW'
    }
  },
  // define methods under the `methods` object
  methods: {
    hideDownloadModalView: function (event) {
      document.querySelector('.modal-view-download').classList.toggle('is-active')
    },
    hideModalView: function (event) {
      document.querySelector('.modal-view').classList.toggle('is-active')
    },
    showDownloadModalView: function (event) {
      document.querySelector('.modal-view').classList.remove('is-active')
      document.querySelector('.modal-view-download').classList.toggle('is-active')
    },
    showModalView: function (event) {
      document.querySelector('.modal-view').classList.toggle('is-active')
    },
    pay: function (event) {
      var divList = document.querySelectorAll('.pay-button')
      var divArray = [...divList]
      divArray.forEach(div => {
        div.classList.remove('is-dark')
      })
      event.target.classList.toggle('is-dark')
      // var buttonPay = document.querySelector('.button-pay')
      var paypalForm = document.getElementById('paypal-form')
      var buttonDownload = document.querySelector('.button-download')
      var price = event.target.innerHTML.replace('€', '')
      paypalForm.elements['amount'].value = price
      if (event.target.innerHTML === 'Grátis') {
        // buttonPay.innerHTML = 'Download'
        buttonDownload.style.display = 'inline'
        paypalForm.style.display = 'none'
      } else {
        buttonDownload.style.display = 'none'
        paypalForm.style.display = 'inline'
        // buttonPay.innerHTML = 'Pagar'
      }
    }
  },
  firebase () {
    return {
      // load settings as object instead of array (default)
      settings: {
        source: settingsRef,
        asObject: true
      },
      posts: {
        source: booksRef,
        asObject: true
      },
      post: {
        source: booksRef.child(this.$route.params.key),
        asObject: true
      },
      nav: {
        source: navRef
      },
      media: {
        source: mediaRef
      }
    }
  },
  updated: function () {
    var elem = document.querySelector('#spinner')
    elem.parentNode.removeChild(elem)
    document.querySelector('#main_content').style.display = 'block'
  },
  mounted: function () {
    if (this.$route.query.show_download) {
      document.querySelector('.modal-view-download').classList.toggle('is-active')
    }
    // document.dispatchEvent(new Event('render-event'))
    // var buttonDownload = document.querySelector('.button-download')
    // var modalView = document.querySelector('.modal-view')
    // var modalViewDownload = document.querySelector('.modal-view-download')
    // buttonDownload.addEventListener('click', function () {
    //   modalView.classList.toggle('is-active')
    //   modalViewDownload.classList.toggle('is-active')
    // })
    // var modalButton = document.querySelector('.modal-button-ebook')
    // modalButton.addEventListener('click', function () {
    //   modalView.classList.toggle('is-active')
    // })
    // // close actions
    // document.querySelector('#button-close').addEventListener('click', function () {
    //   modalView.classList.toggle('is-active')
    // })
    // document.querySelector('#button-close-download').addEventListener('click', function () {
    //   modalViewDownload.classList.toggle('is-active')
    // })
  },
  computed: {
    loadLogo () {
      var i = this.media.length
      var url = null
      while (i--) {
        if (this.media[i].name === 'WebsiteLogo') {
          url = this.media[i].src
        }
      }
      return url
    }
  }
}

</script>

<style lang="scss" scoped>

.authors {
  padding-right: 16px;
  text-decoration: underline;
}
.divider {
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.book-cover {
  -webkit-box-shadow: 0 0 5px rgba(0,0,0,0.6);
  -moz-box-shadow: 0 0 5px rgba(0,0,0,0.6);
  box-shadow: 0 0 5px rgba(0,0,0,0.6);
}
.excerpt {
  padding: 10px;
  // border-top: 1px solid #CCC;
  // border-bottom: 1px solid #CCC;
  border-left: 2px solid #ddd;
  margin-left: 20px;
  margin-right: 20px;
  background-color: white;
  font-size: 110%;
  font-family: Garamond, Baskerville, "Baskerville Old Face", "Hoefler Text", "Times New Roman", serif;
}
.pay-button {
  min-width: 60px;
  margin: 4px;
}
.form-paypal, .button-pay, .button-download {
    width: 100%;
}
.paypal img {
  width:180px;
}
@media screen and (max-width: 768px) {
  .excerpt {
    padding: 5px;
    margin-left: 10px;
    margin-right: 10px;
  }
  .pay-button {
    min-width: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Title.vue